function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 36,
  rx: 3,
  fill: "#B3CDFF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.4688 21.4375H20.8125C20.4644 21.4375 20.1306 21.2992 19.8844 21.0531C19.6383 20.8069 19.5 20.4731 19.5 20.125V16.8438C19.5 16.6697 19.4309 16.5028 19.3078 16.3797C19.1847 16.2566 19.0178 16.1875 18.8438 16.1875H18.1875",
  stroke: "#0050C8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1719 12.9062C19.107 12.9062 19.0435 12.9255 18.9896 12.9615C18.9356 12.9976 18.8936 13.0489 18.8687 13.1088C18.8439 13.1688 18.8374 13.2347 18.8501 13.2984C18.8627 13.362 18.894 13.4205 18.9399 13.4664C18.9857 13.5123 19.0442 13.5435 19.1079 13.5562C19.1715 13.5689 19.2375 13.5624 19.2974 13.5375C19.3574 13.5127 19.4086 13.4706 19.4447 13.4167C19.4808 13.3627 19.5 13.2993 19.5 13.2344C19.5 13.1474 19.4654 13.0639 19.4039 13.0024C19.3424 12.9408 19.2589 12.9062 19.1719 12.9062Z",
  stroke: "#0050C8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5 27.3438C24.9366 27.3438 29.3438 22.9366 29.3438 17.5C29.3438 12.0634 24.9366 7.65625 19.5 7.65625C14.0634 7.65625 9.65625 12.0634 9.65625 17.5C9.65625 22.9366 14.0634 27.3438 19.5 27.3438Z",
  stroke: "#0050C8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  fill: "white",
  transform: "translate(9 7)"
})));

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info_icon.8d0d037b.svg";
export { ForwardRef as ReactComponent };